import { useCallback } from "react";
import { useLocation } from "wouter";

import { useAvailableLanguages } from "../../i18n/useAvailableLanguages";
import { Language, useLanguage } from "../../i18n/useLanguage";

interface LanguageSelectHook {
  (): {
    language: Language;
    oppositeLanguage: Language;
    oppositeLanguageLink: string;
  };
}

export const useLanguageSelect: LanguageSelectHook = () => {
  const [language] = useLanguage();
  const [location] = useLocation();
  const availableLanguages = useAvailableLanguages();

  const getNextLanguage = useCallback(() => {
    const currentIndex = availableLanguages.indexOf(language);
    const nextIndex = (currentIndex + 1) % availableLanguages.length;
    return availableLanguages[nextIndex];
  }, [language, availableLanguages]);

  const oppositeLanguage = getNextLanguage();

  const oppositeLanguageLink =
    location.replace(`/${language}`, `/${oppositeLanguage}`) +
    window.location.search;

  return {
    language,
    oppositeLanguage,
    oppositeLanguageLink,
  };
};
